<template>
  <div :class="windowWidth ? 'mainSideBarDiv' : 'mainSideBarMobile'">
    <v-navigation-drawer
      v-if="windowWidth"
      :width="!mini ? '800' : '69'"
      permanent
      class="white-sidebar"
    >
      <div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          class="mt-2"
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'members' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('members')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.33333 13.2324H2.06667C1.78377 13.2324 1.51246 13.3448 1.31242 13.5448C1.11238 13.7449 1 14.0162 1 14.2991V17.4991H6.33333V13.2324Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9327 13.2324H11.666V17.4991H16.9993V14.2991C16.9993 14.0162 16.887 13.7449 16.6869 13.5448C16.4869 13.3448 16.2156 13.2324 15.9327 13.2324Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.6007 8.9668H7.40065C7.11775 8.9668 6.84644 9.07918 6.6464 9.27922C6.44636 9.47925 6.33398 9.75057 6.33398 10.0335V17.5001H11.6673V10.0335C11.6673 9.75057 11.5549 9.47925 11.3549 9.27922C11.1549 9.07918 10.8835 8.9668 10.6007 8.9668Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.13379 3.36667C7.13379 3.86174 7.33046 4.33653 7.68052 4.6866C8.03059 5.03667 8.50538 5.23333 9.00046 5.23333C9.49553 5.23333 9.97032 5.03667 10.3204 4.6866C10.6705 4.33653 10.8671 3.86174 10.8671 3.36667C10.8671 2.8716 10.6705 2.3968 10.3204 2.04673C9.97032 1.69667 9.49553 1.5 9.00046 1.5C8.50538 1.5 8.03059 1.69667 7.68052 2.04673C7.33046 2.3968 7.13379 2.8716 7.13379 3.36667V3.36667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3097 6.833C11.0247 6.49838 10.6705 6.22964 10.2715 6.04536C9.87243 5.86107 9.43814 5.76563 8.99861 5.76562C8.55908 5.76563 8.1248 5.86107 7.72577 6.04536C7.32674 6.22964 6.97249 6.49838 6.6875 6.833"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.8223 8.16745C12.8223 8.66252 13.0189 9.13731 13.369 9.48738C13.7191 9.83745 14.1939 10.0341 14.6889 10.0341C15.184 10.0341 15.6588 9.83745 16.0089 9.48738C16.3589 9.13731 16.5556 8.66252 16.5556 8.16745C16.5556 7.67238 16.3589 7.19758 16.0089 6.84752C15.6588 6.49745 15.184 6.30078 14.6889 6.30078C14.1939 6.30078 13.7191 6.49745 13.369 6.84752C13.0189 7.19758 12.8223 7.67238 12.8223 8.16745V8.16745Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9998 11.6331C16.616 11.1818 16.1083 10.853 15.5395 10.6873C14.9708 10.5216 14.3659 10.5263 13.7998 10.7008"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.44336 8.16745C1.44336 8.41258 1.49164 8.65532 1.58545 8.88179C1.67926 9.10827 1.81676 9.31404 1.99009 9.48738C2.16343 9.66072 2.36921 9.79821 2.59568 9.89202C2.82216 9.98583 3.06489 10.0341 3.31003 10.0341C3.55516 10.0341 3.79789 9.98583 4.02437 9.89202C4.25084 9.79821 4.45662 9.66072 4.62996 9.48738C4.80329 9.31404 4.94079 9.10827 5.0346 8.88179C5.12841 8.65532 5.17669 8.41258 5.17669 8.16745C5.17669 7.92231 5.12841 7.67958 5.0346 7.45311C4.94079 7.22663 4.80329 7.02085 4.62996 6.84752C4.45662 6.67418 4.25084 6.53668 4.02437 6.44287C3.79789 6.34906 3.55516 6.30078 3.31003 6.30078C3.06489 6.30078 2.82216 6.34906 2.59568 6.44287C2.36921 6.53668 2.16343 6.67418 1.99009 6.84752C1.81676 7.02085 1.67926 7.22663 1.58545 7.45311C1.49164 7.67958 1.44336 7.92231 1.44336 8.16745V8.16745Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 11.6331C1.28558 11.2992 1.63997 11.031 2.03887 10.8469C2.43778 10.6628 2.87177 10.5671 3.31111 10.5664C3.61123 10.5666 3.90964 10.6117 4.19644 10.7001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Members
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'providers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('providers')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2002 11.8C15.6217 12.3923 16.836 13.392 17.6902 14.6733C18.5444 15.9546 19.0002 17.4601 19.0002 19"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.3999 18.9999C3.40282 17.953 3.61687 16.9175 4.02925 15.9553C4.44162 14.9931 5.04385 14.124 5.7999 13.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.2002 10.6V12.4C14.2002 13.1956 13.8841 13.9587 13.3215 14.5213C12.7589 15.0839 11.9958 15.4 11.2002 15.4C10.4045 15.4 9.64148 15.0839 9.07887 14.5213C8.51627 13.9587 8.2002 13.1956 8.2002 12.4V10.6"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.6 9.80009C3.48366 9.80009 4.2 9.08375 4.2 8.2001C4.2 7.31644 3.48366 6.6001 2.6 6.6001C1.71634 6.6001 1 7.31644 1 8.2001C1 9.08375 1.71634 9.80009 2.6 9.80009Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.19238 8.33594C4.66051 8.50144 5.06578 8.80807 5.35234 9.21355C5.6389 9.61903 5.79264 10.1034 5.79238 10.5999V17.1999C5.79238 17.437 5.8392 17.6717 5.93016 17.8906C6.02112 18.1095 6.15442 18.3083 6.32242 18.4756C6.49041 18.6428 6.68979 18.7752 6.9091 18.8652C7.12841 18.9552 7.36333 19.001 7.60038 18.9999H9.40038C9.87777 18.9999 10.3356 18.8103 10.6732 18.4727C11.0107 18.1352 11.2004 17.6773 11.2004 17.1999V15.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.2 9.39999C13.5196 9.39999 15.4 7.51959 15.4 5.2C15.4 2.8804 13.5196 1 11.2 1C8.8804 1 7 2.8804 7 5.2C7 7.51959 8.8804 9.39999 11.2 9.39999Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.6001 3.06396C8.24781 3.73694 9.02422 4.27283 9.88316 4.63977C10.7421 5.00671 11.6661 5.19722 12.6001 5.19996C13.5494 5.20262 14.489 5.00925 15.3601 4.63196"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Providers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'networks'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('networks')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 4.49243C9.93198 4.49243 10.6875 3.73691 10.6875 2.80493C10.6875 1.87295 9.93198 1.11743 9 1.11743C8.06802 1.11743 7.3125 1.87295 7.3125 2.80493C7.3125 3.73691 8.06802 4.49243 9 4.49243Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.97754 5.52759L7.67254 3.84009"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.0625 7.30493C5.68382 7.30493 6.1875 6.80125 6.1875 6.17993C6.1875 5.55861 5.68382 5.05493 5.0625 5.05493C4.44118 5.05493 3.9375 5.55861 3.9375 6.17993C3.9375 6.80125 4.44118 7.30493 5.0625 7.30493Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.0221 5.52759L10.3271 3.84009"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9375 7.30493C13.5588 7.30493 14.0625 6.80125 14.0625 6.17993C14.0625 5.55861 13.5588 5.05493 12.9375 5.05493C12.3162 5.05493 11.8125 5.55861 11.8125 6.17993C11.8125 6.80125 12.3162 7.30493 12.9375 7.30493Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.81219 16.8748L1.30469 14.9998C0.821311 14.4036 0.556635 13.6598 0.554688 12.8923V8.99978C0.554688 8.70141 0.673214 8.41526 0.884192 8.20429C1.09517 7.99331 1.38132 7.87478 1.67969 7.87478V7.87478C1.82805 7.87379 1.97515 7.90216 2.11251 7.95825C2.24987 8.01435 2.37477 8.09706 2.48004 8.20162C2.5853 8.30619 2.66883 8.43054 2.72584 8.56752C2.78284 8.70451 2.81219 8.85141 2.81219 8.99978V11.9098"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.18756 16.8749V14.5199C6.18797 13.8545 5.98948 13.2041 5.61756 12.6524L4.76256 11.3699C4.68988 11.2452 4.5923 11.1369 4.4759 11.0517C4.35951 10.9665 4.2268 10.9062 4.08605 10.8745C3.94531 10.8428 3.79955 10.8405 3.65787 10.8677C3.51618 10.8948 3.38162 10.9509 3.26256 11.0324V11.0324C3.05307 11.1772 2.90335 11.3931 2.84126 11.6401C2.77917 11.8871 2.80895 12.1482 2.92506 12.3749L3.93756 14.0624"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.1875 16.8748L16.6875 14.9848C17.1709 14.3885 17.4356 13.6448 17.4375 12.8773V8.99976C17.4375 8.70139 17.319 8.41524 17.108 8.20426C16.897 7.99328 16.6109 7.87476 16.3125 7.87476C16.0141 7.87476 15.728 7.99328 15.517 8.20426C15.306 8.41524 15.1875 8.70139 15.1875 8.99976V11.9098"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.8125 16.8749V14.5199C11.8121 13.8545 12.0106 13.2041 12.3825 12.6524L13.2375 11.3699C13.3102 11.2452 13.4078 11.1369 13.5242 11.0517C13.6406 10.9665 13.7733 10.9062 13.914 10.8745C14.0548 10.8428 14.2005 10.8405 14.3422 10.8677C14.4839 10.8948 14.6184 10.9509 14.7375 11.0324C14.9495 11.1749 15.1023 11.3899 15.1672 11.6371C15.2321 11.8842 15.2047 12.1465 15.09 12.3749L14.0775 14.0624"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              VNets
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'utilization'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('utilization')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.92969 5.42578V9.28292"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.92801 13.7857C10.2831 13.7857 10.5709 13.4979 10.5709 13.1429C10.5709 12.7878 10.2831 12.5 9.92801 12.5C9.57297 12.5 9.28516 12.7878 9.28516 13.1429C9.28516 13.4979 9.57297 13.7857 9.92801 13.7857Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.95495 1.97083L1.97278 8.953C1.43553 9.49025 1.43553 10.3613 1.97278 10.8986L8.95495 17.8807C9.4922 18.418 10.3633 18.418 10.9005 17.8807L17.8827 10.8986C18.4199 10.3613 18.4199 9.49025 17.8827 8.953L10.9005 1.97083C10.3633 1.43358 9.4922 1.43358 8.95495 1.97083Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Utilization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'contract'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('contract')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1707 1H3.39468C2.75957 1 2.15047 1.25286 1.70139 1.70294C1.2523 2.15303 1 2.76348 1 3.4V17.8C1 18.1183 1.12615 18.4235 1.35069 18.6485C1.57524 18.8736 1.87979 19 2.19734 19H3.3388"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.39453 4.80005H9.18167"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.39453 8H7.27391"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.375 8.2V2.8C12.375 2.32261 12.5642 1.86477 12.901 1.52721C13.2379 1.18964 13.6947 1 14.171 1V1C14.6473 1 15.1042 1.18964 15.441 1.52721C15.7778 1.86477 15.967 2.32261 15.967 2.8V4.8H12.375"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.763 16.0881L13.9395 16.8561"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.3215 12.5121L12.5175 13.2721C12.3764 13.3333 12.2243 13.3649 12.0705 13.3649C11.9167 13.3649 11.7646 13.3333 11.6235 13.2721C11.4152 13.1775 11.2379 13.0258 11.1119 12.8346C10.9859 12.6433 10.9164 12.4203 10.9114 12.1912C10.9064 11.9621 10.9661 11.7362 11.0836 11.5396C11.2011 11.343 11.3717 11.1837 11.5756 11.0801L13.3796 10.1761C13.602 10.0619 13.8481 10.0016 14.098 10.0001C14.2866 9.99817 14.4738 10.0335 14.6488 10.1041L18.3366 11.6001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.94629 16.8881H8.21547L10.6501 18.7441C10.7071 18.8089 10.7763 18.8617 10.8538 18.8996C10.9312 18.9375 11.0154 18.9597 11.1014 18.9649C11.1875 18.9701 11.2737 18.9582 11.3551 18.93C11.4365 18.9017 11.5116 18.8576 11.576 18.8001L14.9764 15.9841C15.1122 15.8743 15.1992 15.7152 15.2186 15.5415C15.238 15.3678 15.1883 15.1934 15.0802 15.0561L13.1725 12.9841"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3686 11.2082L11.1691 11.0402C10.9183 10.875 10.6229 10.7912 10.323 10.8002C10.1404 10.8002 9.95933 10.8327 9.78814 10.8962L6.93848 12.0802"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.78906 17.4882H6.02853C6.14807 17.4946 6.26771 17.4774 6.38059 17.4375C6.49347 17.3975 6.59738 17.3356 6.68636 17.2554C6.77534 17.1751 6.84765 17.0781 6.89913 16.9697C6.95062 16.8614 6.98028 16.744 6.9864 16.6242V12.3442C6.97199 12.1036 6.86315 11.8785 6.68367 11.7181C6.50418 11.5577 6.26865 11.4751 6.02853 11.4882H5.78906"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9602 17.4882H18.7606C18.6411 17.4946 18.5214 17.4774 18.4085 17.4375C18.2957 17.3975 18.1918 17.3356 18.1028 17.2554C18.0138 17.1751 17.9415 17.0781 17.89 16.9697C17.8385 16.8614 17.8089 16.744 17.8027 16.6242V12.3442C17.8171 12.1036 17.926 11.8785 18.1055 11.7181C18.285 11.5577 18.5205 11.4751 18.7606 11.4882H19.0001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Contracts
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'partners'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('partners')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-3 mt-lg-2 mt-md-1 ' : 'ml-4 mt-xl-3 mt-lg-2 mt-md-1'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7822H5.30375L8.11175 18.1549C8.21361 18.3455 8.33692 18.4993 8.47436 18.6071C8.61179 18.7148 8.76054 18.7744 8.91175 18.7822C10.5465 16.7765 12.0823 14.5464 13.5037 12.114C13.5917 11.6913 13.4238 11.2686 13.2718 10.914L11.2637 6.49585"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41871H2.6C2.80154 2.41761 2.99589 2.54621 3.14421 2.77879C3.29253 3.01138 3.38388 3.33082 3.4 3.67325V12.4278C3.38198 12.7677 3.2898 13.0838 3.14168 13.3136C2.99356 13.5433 2.80027 13.67 2.6 13.6687H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6687H17.3996C17.1993 13.67 17.0061 13.5433 16.8579 13.3136C16.7098 13.0838 16.6176 12.7677 16.5996 12.4278V3.67325C16.6157 3.33082 16.7071 3.01138 16.8554 2.77879C17.0037 2.54621 17.1981 2.41761 17.3996 2.41871H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Partners
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'settings' ||
            watchActiveItem == 'settings/account' ||
            watchActiveItem == 'settings/users'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
              @click="activeItem('settings')"
              class="list-item-icon no-padding"
              :class="!mini ? 'ml-xl-4 ml-lg-4  ml-md-1 ' : 'ml-4'"
            >
              <svg
                width="16"
                class="pointer mt-3"
                height="16"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.96501 2.19798C8.09556 2.34292 8.25511 2.45881 8.43331 2.53814C8.61151 2.61746 8.80438 2.65845 8.99944 2.65845C9.19449 2.65845 9.38737 2.61746 9.56557 2.53814C9.74377 2.45881 9.90331 2.34292 10.0339 2.19798L10.7069 1.4594C10.8998 1.2459 11.154 1.09733 11.4347 1.03408C11.7153 0.970841 12.0087 0.996024 12.2745 1.10618C12.5403 1.21633 12.7655 1.40605 12.9192 1.64931C13.0729 1.89257 13.1475 2.17743 13.1329 2.46481L13.0824 3.46097C13.0726 3.6553 13.1036 3.84952 13.1735 4.03112C13.2433 4.21272 13.3504 4.37768 13.4879 4.51536C13.6254 4.65304 13.7901 4.7604 13.9716 4.83052C14.1531 4.90064 14.3472 4.93197 14.5415 4.92248L15.5375 4.87196C15.8247 4.8578 16.1092 4.93281 16.3521 5.0867C16.5949 5.24059 16.7843 5.46583 16.8941 5.73155C17.004 5.99728 17.029 6.29048 16.9657 6.57097C16.9024 6.85146 16.754 7.10552 16.5407 7.29832L15.7994 7.96717C15.6546 8.09793 15.5389 8.2576 15.4597 8.43587C15.3805 8.61414 15.3396 8.80704 15.3396 9.00211C15.3396 9.19719 15.3805 9.39009 15.4597 9.56836C15.5389 9.74663 15.6546 9.9063 15.7994 10.0371L16.5407 10.7059C16.7541 10.8988 16.9027 11.1531 16.9659 11.4338C17.0292 11.7145 17.004 12.0079 16.8938 12.2738C16.7837 12.5396 16.594 12.7648 16.3508 12.9185C16.1076 13.0722 15.8227 13.1469 15.5354 13.1323L14.5394 13.0817C14.3447 13.0717 14.15 13.1027 13.968 13.1727C13.786 13.2427 13.6207 13.3501 13.4828 13.488C13.345 13.6259 13.2376 13.7912 13.1676 13.9732C13.0976 14.1552 13.0667 14.3499 13.0767 14.5447L13.1272 15.5408C13.1399 15.8268 13.0644 16.1097 12.9107 16.3512C12.7571 16.5927 12.5329 16.781 12.2685 16.8906C12.0041 17.0002 11.7124 17.0257 11.433 16.9637C11.1537 16.9017 10.9001 16.7552 10.7069 16.5441L10.0374 15.8034C9.90675 15.6587 9.74717 15.5429 9.56898 15.4637C9.3908 15.3846 9.19798 15.3436 9.003 15.3436C8.80801 15.3436 8.61519 15.3846 8.43701 15.4637C8.25882 15.5429 8.09924 15.6587 7.96857 15.8034L7.29626 16.5441C7.10332 16.7562 6.84968 16.9036 6.56991 16.9663C6.29014 17.029 5.99786 17.0038 5.73291 16.8943C5.46795 16.7847 5.24323 16.5961 5.08936 16.3542C4.93549 16.1122 4.85998 15.8287 4.8731 15.5423L4.92433 14.5461C4.93434 14.3513 4.90337 14.1567 4.8334 13.9746C4.76344 13.7926 4.65604 13.6273 4.51817 13.4894C4.38029 13.3515 4.21501 13.2441 4.03301 13.1741C3.851 13.1041 3.65634 13.0732 3.46161 13.0832L2.4656 13.1337C2.17838 13.1487 1.89357 13.0744 1.65025 12.921C1.40694 12.7676 1.21706 12.5427 1.10667 12.2771C0.996293 12.0115 0.970825 11.7182 1.03377 11.4375C1.09671 11.1568 1.24497 10.9025 1.45821 10.7095L2.19881 10.0406C2.34355 9.90986 2.45926 9.75018 2.53845 9.57192C2.61764 9.39365 2.65855 9.20074 2.65855 9.00567C2.65855 8.8106 2.61764 8.6177 2.53845 8.43943C2.45926 8.26116 2.34355 8.10149 2.19881 7.97073L1.45821 7.29832C1.24567 7.1055 1.09785 6.85172 1.03497 6.5717C0.972097 6.29167 0.997222 5.99906 1.10692 5.73385C1.21661 5.46865 1.40552 5.24379 1.64782 5.09003C1.89012 4.93627 2.17399 4.86111 2.46062 4.87481L3.45663 4.92533C3.65173 4.93559 3.8468 4.90469 4.02918 4.83463C4.21156 4.76458 4.37717 4.65694 4.51524 4.51871C4.65332 4.38048 4.76078 4.21474 4.83065 4.03227C4.90051 3.8498 4.93122 3.65466 4.92077 3.45955L4.8731 2.46268C4.85966 2.17611 4.93495 1.89238 5.0887 1.65019C5.24245 1.40801 5.46717 1.21917 5.73219 1.10944C5.99722 0.999708 6.28964 0.974435 6.56955 1.03707C6.84947 1.0997 7.10325 1.24719 7.29626 1.4594L7.96501 2.19798Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.79688 9.00273C5.79688 9.85193 6.13417 10.6664 6.73456 11.2668C7.33495 11.8673 8.14926 12.2047 8.99834 12.2047C9.84742 12.2047 10.6617 11.8673 11.2621 11.2668C11.8625 10.6664 12.1998 9.85193 12.1998 9.00273C12.1998 8.15352 11.8625 7.33909 11.2621 6.73861C10.6617 6.13813 9.84742 5.80078 8.99834 5.80078C8.14926 5.80078 7.33495 6.13813 6.73456 6.73861C6.13417 7.33909 5.79688 8.15352 5.79688 9.00273V9.00273Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'settings' ||
                watchActiveItem == 'settings/account' ||
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('settings')"
              class="text-gray-darker"
              >Settings
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'settings/account'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer ml-3"
              @click="activeItem('settings/account')"
            >
              Account
            </div>

            <div
              :class="
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-1 ml-3"
              @click="activeItem('settings/users')"
            >
              Users
            </div>
          </div>
        </v-list-group>
      </div>
      <div>
        <v-divider></v-divider>
        <v-list-item two-line v-if="!mini" class="mb-2">
          <span class="orange--text mt-1 ml-1" style="font-size: 9px">
            Powered by:
          </span>

          <v-list-item-content
            class="no-padding pointer justify-center mt-2 mb-2"
          >
            <v-list-item-title
              class="d-flex mb-3 align-center text-center text-gray-darker"
            >
              <img src="/apalyhealthlogo.png" alt="" class="mt-1 ml-1" />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item two-line v-else>
          <v-list-item-content class="no-padding pointer">
            <v-list-item-title
              class="d-flex mb-3 align-center text-center font text-gray-darker"
            >
              <img
                src="/apaly1.png"
                class="ml-1"
                width="95"
                height="45"
                alt=""
              />
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-navigation-drawer>
    <!-- Mobile -->
    <v-navigation-drawer v-else permanent class="white-sidebar-onmobile mt-4">
      <div>
        <v-divider></v-divider>
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'home' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('home')"
        >
          <v-list-item-icon
           class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7319 6.49L9.00356 0.659668L1.26809 6.49C1.10817 6.63755 1.01201 6.84157 1 7.05881V15.9622C1.00056 16.1464 1.07402 16.323 1.20432 16.4532C1.33462 16.5835 1.51119 16.657 1.69547 16.6575H6.33333V12.9268C6.33333 12.2197 6.61429 11.5415 7.11438 11.0415C7.61448 10.5414 8.29276 10.2605 9 10.2605C9.70724 10.2605 10.3855 10.5414 10.8856 11.0415C11.3857 11.5415 11.6667 12.2197 11.6667 12.9268V16.6597H16.3038C16.4882 16.6591 16.6648 16.5857 16.7952 16.4554C16.9256 16.3252 16.9993 16.1486 17 15.9643V7.05881C16.9877 6.84165 16.8916 6.63773 16.7319 6.49Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Home
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'members' ? 'pointer active' : 'pointer inactive'
          "
          @click="activeItem('members')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.33333 13.2324H2.06667C1.78377 13.2324 1.51246 13.3448 1.31242 13.5448C1.11238 13.7449 1 14.0162 1 14.2991V17.4991H6.33333V13.2324Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.9327 13.2324H11.666V17.4991H16.9993V14.2991C16.9993 14.0162 16.887 13.7449 16.6869 13.5448C16.4869 13.3448 16.2156 13.2324 15.9327 13.2324Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.6007 8.9668H7.40065C7.11775 8.9668 6.84644 9.07918 6.6464 9.27922C6.44636 9.47925 6.33398 9.75057 6.33398 10.0335V17.5001H11.6673V10.0335C11.6673 9.75057 11.5549 9.47925 11.3549 9.27922C11.1549 9.07918 10.8835 8.9668 10.6007 8.9668Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.13379 3.36667C7.13379 3.86174 7.33046 4.33653 7.68052 4.6866C8.03059 5.03667 8.50538 5.23333 9.00046 5.23333C9.49553 5.23333 9.97032 5.03667 10.3204 4.6866C10.6705 4.33653 10.8671 3.86174 10.8671 3.36667C10.8671 2.8716 10.6705 2.3968 10.3204 2.04673C9.97032 1.69667 9.49553 1.5 9.00046 1.5C8.50538 1.5 8.03059 1.69667 7.68052 2.04673C7.33046 2.3968 7.13379 2.8716 7.13379 3.36667V3.36667Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3097 6.833C11.0247 6.49838 10.6705 6.22964 10.2715 6.04536C9.87243 5.86107 9.43814 5.76563 8.99861 5.76562C8.55908 5.76563 8.1248 5.86107 7.72577 6.04536C7.32674 6.22964 6.97249 6.49838 6.6875 6.833"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.8223 8.16745C12.8223 8.66252 13.0189 9.13731 13.369 9.48738C13.7191 9.83745 14.1939 10.0341 14.6889 10.0341C15.184 10.0341 15.6588 9.83745 16.0089 9.48738C16.3589 9.13731 16.5556 8.66252 16.5556 8.16745C16.5556 7.67238 16.3589 7.19758 16.0089 6.84752C15.6588 6.49745 15.184 6.30078 14.6889 6.30078C14.1939 6.30078 13.7191 6.49745 13.369 6.84752C13.0189 7.19758 12.8223 7.67238 12.8223 8.16745V8.16745Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M16.9998 11.6331C16.616 11.1818 16.1083 10.853 15.5395 10.6873C14.9708 10.5216 14.3659 10.5263 13.7998 10.7008"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1.44336 8.16745C1.44336 8.41258 1.49164 8.65532 1.58545 8.88179C1.67926 9.10827 1.81676 9.31404 1.99009 9.48738C2.16343 9.66072 2.36921 9.79821 2.59568 9.89202C2.82216 9.98583 3.06489 10.0341 3.31003 10.0341C3.55516 10.0341 3.79789 9.98583 4.02437 9.89202C4.25084 9.79821 4.45662 9.66072 4.62996 9.48738C4.80329 9.31404 4.94079 9.10827 5.0346 8.88179C5.12841 8.65532 5.17669 8.41258 5.17669 8.16745C5.17669 7.92231 5.12841 7.67958 5.0346 7.45311C4.94079 7.22663 4.80329 7.02085 4.62996 6.84752C4.45662 6.67418 4.25084 6.53668 4.02437 6.44287C3.79789 6.34906 3.55516 6.30078 3.31003 6.30078C3.06489 6.30078 2.82216 6.34906 2.59568 6.44287C2.36921 6.53668 2.16343 6.67418 1.99009 6.84752C1.81676 7.02085 1.67926 7.22663 1.58545 7.45311C1.49164 7.67958 1.44336 7.92231 1.44336 8.16745V8.16745Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 11.6331C1.28558 11.2992 1.63997 11.031 2.03887 10.8469C2.43778 10.6628 2.87177 10.5671 3.31111 10.5664C3.61123 10.5666 3.90964 10.6117 4.19644 10.7001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Members
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'providers'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('providers')"
        >
          <v-list-item-icon
             class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.2002 11.8C15.6217 12.3923 16.836 13.392 17.6902 14.6733C18.5444 15.9546 19.0002 17.4601 19.0002 19"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.3999 18.9999C3.40282 17.953 3.61687 16.9175 4.02925 15.9553C4.44162 14.9931 5.04385 14.124 5.7999 13.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.2002 10.6V12.4C14.2002 13.1956 13.8841 13.9587 13.3215 14.5213C12.7589 15.0839 11.9958 15.4 11.2002 15.4C10.4045 15.4 9.64148 15.0839 9.07887 14.5213C8.51627 13.9587 8.2002 13.1956 8.2002 12.4V10.6"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.6 9.80009C3.48366 9.80009 4.2 9.08375 4.2 8.2001C4.2 7.31644 3.48366 6.6001 2.6 6.6001C1.71634 6.6001 1 7.31644 1 8.2001C1 9.08375 1.71634 9.80009 2.6 9.80009Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M4.19238 8.33594C4.66051 8.50144 5.06578 8.80807 5.35234 9.21355C5.6389 9.61903 5.79264 10.1034 5.79238 10.5999V17.1999C5.79238 17.437 5.8392 17.6717 5.93016 17.8906C6.02112 18.1095 6.15442 18.3083 6.32242 18.4756C6.49041 18.6428 6.68979 18.7752 6.9091 18.8652C7.12841 18.9552 7.36333 19.001 7.60038 18.9999H9.40038C9.87777 18.9999 10.3356 18.8103 10.6732 18.4727C11.0107 18.1352 11.2004 17.6773 11.2004 17.1999V15.3999"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.2 9.39999C13.5196 9.39999 15.4 7.51959 15.4 5.2C15.4 2.8804 13.5196 1 11.2 1C8.8804 1 7 2.8804 7 5.2C7 7.51959 8.8804 9.39999 11.2 9.39999Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.6001 3.06396C8.24781 3.73694 9.02422 4.27283 9.88316 4.63977C10.7421 5.00671 11.6661 5.19722 12.6001 5.19996C13.5494 5.20262 14.489 5.00925 15.3601 4.63196"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Providers
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item
          two-line
          :class="
            watchActiveItem == 'networks'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('networks')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9 4.49243C9.93198 4.49243 10.6875 3.73691 10.6875 2.80493C10.6875 1.87295 9.93198 1.11743 9 1.11743C8.06802 1.11743 7.3125 1.87295 7.3125 2.80493C7.3125 3.73691 8.06802 4.49243 9 4.49243Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.97754 5.52759L7.67254 3.84009"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.0625 7.30493C5.68382 7.30493 6.1875 6.80125 6.1875 6.17993C6.1875 5.55861 5.68382 5.05493 5.0625 5.05493C4.44118 5.05493 3.9375 5.55861 3.9375 6.17993C3.9375 6.80125 4.44118 7.30493 5.0625 7.30493Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.0221 5.52759L10.3271 3.84009"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.9375 7.30493C13.5588 7.30493 14.0625 6.80125 14.0625 6.17993C14.0625 5.55861 13.5588 5.05493 12.9375 5.05493C12.3162 5.05493 11.8125 5.55861 11.8125 6.17993C11.8125 6.80125 12.3162 7.30493 12.9375 7.30493Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M2.81219 16.8748L1.30469 14.9998C0.821311 14.4036 0.556635 13.6598 0.554688 12.8923V8.99978C0.554688 8.70141 0.673214 8.41526 0.884192 8.20429C1.09517 7.99331 1.38132 7.87478 1.67969 7.87478V7.87478C1.82805 7.87379 1.97515 7.90216 2.11251 7.95825C2.24987 8.01435 2.37477 8.09706 2.48004 8.20162C2.5853 8.30619 2.66883 8.43054 2.72584 8.56752C2.78284 8.70451 2.81219 8.85141 2.81219 8.99978V11.9098"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.18756 16.8749V14.5199C6.18797 13.8545 5.98948 13.2041 5.61756 12.6524L4.76256 11.3699C4.68988 11.2452 4.5923 11.1369 4.4759 11.0517C4.35951 10.9665 4.2268 10.9062 4.08605 10.8745C3.94531 10.8428 3.79955 10.8405 3.65787 10.8677C3.51618 10.8948 3.38162 10.9509 3.26256 11.0324V11.0324C3.05307 11.1772 2.90335 11.3931 2.84126 11.6401C2.77917 11.8871 2.80895 12.1482 2.92506 12.3749L3.93756 14.0624"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.1875 16.8748L16.6875 14.9848C17.1709 14.3885 17.4356 13.6448 17.4375 12.8773V8.99976C17.4375 8.70139 17.319 8.41524 17.108 8.20426C16.897 7.99328 16.6109 7.87476 16.3125 7.87476C16.0141 7.87476 15.728 7.99328 15.517 8.20426C15.306 8.41524 15.1875 8.70139 15.1875 8.99976V11.9098"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.8125 16.8749V14.5199C11.8121 13.8545 12.0106 13.2041 12.3825 12.6524L13.2375 11.3699C13.3102 11.2452 13.4078 11.1369 13.5242 11.0517C13.6406 10.9665 13.7733 10.9062 13.914 10.8745C14.0548 10.8428 14.2005 10.8405 14.3422 10.8677C14.4839 10.8948 14.6184 10.9509 14.7375 11.0324C14.9495 11.1749 15.1023 11.3899 15.1672 11.6371C15.2321 11.8842 15.2047 12.1465 15.09 12.3749L14.0775 14.0624"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              VNets
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
<!-- 
        <v-list-item
          two-line
          :class="
            watchActiveItem == 'utilization'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('utilization')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding"
            :class="
              !mini ? 'ml-xl-4 ml-lg-4  ml-md-1 mt-xl-4 mt-lg-4 ' : 'ml-4 mt-4'
            "
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.92969 5.42578V9.28292"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.92801 13.7857C10.2831 13.7857 10.5709 13.4979 10.5709 13.1429C10.5709 12.7878 10.2831 12.5 9.92801 12.5C9.57297 12.5 9.28516 12.7878 9.28516 13.1429C9.28516 13.4979 9.57297 13.7857 9.92801 13.7857Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.95495 1.97083L1.97278 8.953C1.43553 9.49025 1.43553 10.3613 1.97278 10.8986L8.95495 17.8807C9.4922 18.418 10.3633 18.418 10.9005 17.8807L17.8827 10.8986C18.4199 10.3613 18.4199 9.49025 17.8827 8.953L10.9005 1.97083C10.3633 1.43358 9.4922 1.43358 8.95495 1.97083Z"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Utilization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'contract'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('contract')"
        >
          <v-list-item-icon
             class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.1707 1H3.39468C2.75957 1 2.15047 1.25286 1.70139 1.70294C1.2523 2.15303 1 2.76348 1 3.4V17.8C1 18.1183 1.12615 18.4235 1.35069 18.6485C1.57524 18.8736 1.87979 19 2.19734 19H3.3388"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.39453 4.80005H9.18167"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.39453 8H7.27391"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.375 8.2V2.8C12.375 2.32261 12.5642 1.86477 12.901 1.52721C13.2379 1.18964 13.6947 1 14.171 1V1C14.6473 1 15.1042 1.18964 15.441 1.52721C15.7778 1.86477 15.967 2.32261 15.967 2.8V4.8H12.375"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.763 16.0881L13.9395 16.8561"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M14.3215 12.5121L12.5175 13.2721C12.3764 13.3333 12.2243 13.3649 12.0705 13.3649C11.9167 13.3649 11.7646 13.3333 11.6235 13.2721C11.4152 13.1775 11.2379 13.0258 11.1119 12.8346C10.9859 12.6433 10.9164 12.4203 10.9114 12.1912C10.9064 11.9621 10.9661 11.7362 11.0836 11.5396C11.2011 11.343 11.3717 11.1837 11.5756 11.0801L13.3796 10.1761C13.602 10.0619 13.8481 10.0016 14.098 10.0001C14.2866 9.99817 14.4738 10.0335 14.6488 10.1041L18.3366 11.6001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M6.94629 16.8881H8.21547L10.6501 18.7441C10.7071 18.8089 10.7763 18.8617 10.8538 18.8996C10.9312 18.9375 11.0154 18.9597 11.1014 18.9649C11.1875 18.9701 11.2737 18.9582 11.3551 18.93C11.4365 18.9017 11.5116 18.8576 11.576 18.8001L14.9764 15.9841C15.1122 15.8743 15.1992 15.7152 15.2186 15.5415C15.238 15.3678 15.1883 15.1934 15.0802 15.0561L13.1725 12.9841"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M11.3686 11.2082L11.1691 11.0402C10.9183 10.875 10.6229 10.7912 10.323 10.8002C10.1404 10.8002 9.95933 10.8327 9.78814 10.8962L6.93848 12.0802"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.78906 17.4882H6.02853C6.14807 17.4946 6.26771 17.4774 6.38059 17.4375C6.49347 17.3975 6.59738 17.3356 6.68636 17.2554C6.77534 17.1751 6.84765 17.0781 6.89913 16.9697C6.95062 16.8614 6.98028 16.744 6.9864 16.6242V12.3442C6.97199 12.1036 6.86315 11.8785 6.68367 11.7181C6.50418 11.5577 6.26865 11.4751 6.02853 11.4882H5.78906"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9602 17.4882H18.7606C18.6411 17.4946 18.5214 17.4774 18.4085 17.4375C18.2957 17.3975 18.1918 17.3356 18.1028 17.2554C18.0138 17.1751 17.9415 17.0781 17.89 16.9697C17.8385 16.8614 17.8089 16.744 17.8027 16.6242V12.3442C17.8171 12.1036 17.926 11.8785 18.1055 11.7181C18.285 11.5577 18.5205 11.4751 18.7606 11.4882H19.0001"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Contracts
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          two-line
          :class="
            watchActiveItem == 'partners'
              ? 'pointer active'
              : 'pointer inactive'
          "
          @click="activeItem('partners')"
        >
          <v-list-item-icon
            class="list-item-icon no-padding  ml-4  ml-md-1 mt-3"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.6322 12.7686L12.2002 14.2685"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.34375 12.7822H5.30375L8.11175 18.1549C8.21361 18.3455 8.33692 18.4993 8.47436 18.6071C8.61179 18.7148 8.76054 18.7744 8.91175 18.7822C10.5465 16.7765 12.0823 14.5464 13.5037 12.114C13.5917 11.6913 13.4238 11.2686 13.2718 10.914L11.2637 6.49585"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.86439 3.0732L8.58439 2.66411C8.29678 2.31524 7.95338 2.12489 7.60039 2.11866C7.38661 2.11788 7.17475 2.18733 6.97639 2.3232L3.40039 4.75046"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M1 2.41871H2.6C2.80154 2.41761 2.99589 2.54621 3.14421 2.77879C3.29253 3.01138 3.38388 3.33082 3.4 3.67325V12.4278C3.38198 12.7677 3.2898 13.0838 3.14168 13.3136C2.99356 13.5433 2.80027 13.67 2.6 13.6687H1"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.9996 13.6687H17.3996C17.1993 13.67 17.0061 13.5433 16.8579 13.3136C16.7098 13.0838 16.6176 12.7677 16.5996 12.4278V3.67325C16.6157 3.33082 16.7071 3.01138 16.8554 2.77879C17.0037 2.54621 17.1981 2.41761 17.3996 2.41871H18.9996"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.2001 5.96411L9.44014 7.51864C9.13574 7.70007 8.80248 7.68026 8.50623 7.46312C8.20998 7.24598 7.97229 6.84732 7.84014 6.34592C7.69777 5.82356 7.67992 5.22738 7.79035 4.68302C7.90078 4.13866 8.13088 3.68863 8.43214 3.42775L11.1201 1.12322C11.3827 0.895505 11.6735 0.778592 11.9681 0.782313C12.1862 0.784815 12.4025 0.849337 12.6081 0.973221L16.6081 3.45503"
                stroke="#707070"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-content class="no-padding">
            <v-list-item-title
              class="
                d-flex
                align-center
                font-quicksand-medium-12
                text-gray-darker
              "
            >
              Partners
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-group
          :value="false"
          :class="
            watchActiveItem == 'settings'
              ? 'pointer active-settings'
              : 'pointer  inactive'
          "
        >
          <template v-slot:activator>
            <v-list-item-icon
              class="list-item-icon no-padding  ml-4  ml-md-1 "
            >
              <svg
                width="18"
                class="pointer mt-3"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.96501 2.19798C8.09556 2.34292 8.25511 2.45881 8.43331 2.53814C8.61151 2.61746 8.80438 2.65845 8.99944 2.65845C9.19449 2.65845 9.38737 2.61746 9.56557 2.53814C9.74377 2.45881 9.90331 2.34292 10.0339 2.19798L10.7069 1.4594C10.8998 1.2459 11.154 1.09733 11.4347 1.03408C11.7153 0.970841 12.0087 0.996024 12.2745 1.10618C12.5403 1.21633 12.7655 1.40605 12.9192 1.64931C13.0729 1.89257 13.1475 2.17743 13.1329 2.46481L13.0824 3.46097C13.0726 3.6553 13.1036 3.84952 13.1735 4.03112C13.2433 4.21272 13.3504 4.37768 13.4879 4.51536C13.6254 4.65304 13.7901 4.7604 13.9716 4.83052C14.1531 4.90064 14.3472 4.93197 14.5415 4.92248L15.5375 4.87196C15.8247 4.8578 16.1092 4.93281 16.3521 5.0867C16.5949 5.24059 16.7843 5.46583 16.8941 5.73155C17.004 5.99728 17.029 6.29048 16.9657 6.57097C16.9024 6.85146 16.754 7.10552 16.5407 7.29832L15.7994 7.96717C15.6546 8.09793 15.5389 8.2576 15.4597 8.43587C15.3805 8.61414 15.3396 8.80704 15.3396 9.00211C15.3396 9.19719 15.3805 9.39009 15.4597 9.56836C15.5389 9.74663 15.6546 9.9063 15.7994 10.0371L16.5407 10.7059C16.7541 10.8988 16.9027 11.1531 16.9659 11.4338C17.0292 11.7145 17.004 12.0079 16.8938 12.2738C16.7837 12.5396 16.594 12.7648 16.3508 12.9185C16.1076 13.0722 15.8227 13.1469 15.5354 13.1323L14.5394 13.0817C14.3447 13.0717 14.15 13.1027 13.968 13.1727C13.786 13.2427 13.6207 13.3501 13.4828 13.488C13.345 13.6259 13.2376 13.7912 13.1676 13.9732C13.0976 14.1552 13.0667 14.3499 13.0767 14.5447L13.1272 15.5408C13.1399 15.8268 13.0644 16.1097 12.9107 16.3512C12.7571 16.5927 12.5329 16.781 12.2685 16.8906C12.0041 17.0002 11.7124 17.0257 11.433 16.9637C11.1537 16.9017 10.9001 16.7552 10.7069 16.5441L10.0374 15.8034C9.90675 15.6587 9.74717 15.5429 9.56898 15.4637C9.3908 15.3846 9.19798 15.3436 9.003 15.3436C8.80801 15.3436 8.61519 15.3846 8.43701 15.4637C8.25882 15.5429 8.09924 15.6587 7.96857 15.8034L7.29626 16.5441C7.10332 16.7562 6.84968 16.9036 6.56991 16.9663C6.29014 17.029 5.99786 17.0038 5.73291 16.8943C5.46795 16.7847 5.24323 16.5961 5.08936 16.3542C4.93549 16.1122 4.85998 15.8287 4.8731 15.5423L4.92433 14.5461C4.93434 14.3513 4.90337 14.1567 4.8334 13.9746C4.76344 13.7926 4.65604 13.6273 4.51817 13.4894C4.38029 13.3515 4.21501 13.2441 4.03301 13.1741C3.851 13.1041 3.65634 13.0732 3.46161 13.0832L2.4656 13.1337C2.17838 13.1487 1.89357 13.0744 1.65025 12.921C1.40694 12.7676 1.21706 12.5427 1.10667 12.2771C0.996293 12.0115 0.970825 11.7182 1.03377 11.4375C1.09671 11.1568 1.24497 10.9025 1.45821 10.7095L2.19881 10.0406C2.34355 9.90986 2.45926 9.75018 2.53845 9.57192C2.61764 9.39365 2.65855 9.20074 2.65855 9.00567C2.65855 8.8106 2.61764 8.6177 2.53845 8.43943C2.45926 8.26116 2.34355 8.10149 2.19881 7.97073L1.45821 7.29832C1.24567 7.1055 1.09785 6.85172 1.03497 6.5717C0.972097 6.29167 0.997222 5.99906 1.10692 5.73385C1.21661 5.46865 1.40552 5.24379 1.64782 5.09003C1.89012 4.93627 2.17399 4.86111 2.46062 4.87481L3.45663 4.92533C3.65173 4.93559 3.8468 4.90469 4.02918 4.83463C4.21156 4.76458 4.37717 4.65694 4.51524 4.51871C4.65332 4.38048 4.76078 4.21474 4.83065 4.03227C4.90051 3.8498 4.93122 3.65466 4.92077 3.45955L4.8731 2.46268C4.85966 2.17611 4.93495 1.89238 5.0887 1.65019C5.24245 1.40801 5.46717 1.21917 5.73219 1.10944C5.99722 0.999708 6.28964 0.974435 6.56955 1.03707C6.84947 1.0997 7.10325 1.24719 7.29626 1.4594L7.96501 2.19798Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5.79688 9.00273C5.79688 9.85193 6.13417 10.6664 6.73456 11.2668C7.33495 11.8673 8.14926 12.2047 8.99834 12.2047C9.84742 12.2047 10.6617 11.8673 11.2621 11.2668C11.8625 10.6664 12.1998 9.85193 12.1998 9.00273C12.1998 8.15352 11.8625 7.33909 11.2621 6.73861C10.6617 6.13813 9.84742 5.80078 8.99834 5.80078C8.14926 5.80078 7.33495 6.13813 6.73456 6.73861C6.13417 7.33909 5.79688 8.15352 5.79688 9.00273V9.00273Z"
                  stroke="#707070"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </v-list-item-icon>
            <v-list-item-title
              :class="
                watchActiveItem == 'settings'
                  ? 'pointer active-settings font-quicksand-medium-12 '
                  : 'pointer inactive font-quicksand-medium-12'
              "
              @click="activeItem('settings')"
              class="text-gray-darker"
              >Settings
            </v-list-item-title>
          </template>
          <div class="ml-16 text-gray-darker font-quicksand-medium-12">
            <div
              :class="
                watchActiveItem == 'settings/account'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer"
              @click="activeItem('settings/account')"
            >
              Account
            </div>

            <div
              :class="
                watchActiveItem == 'settings/users'
                  ? 'pointer active-settings'
                  : 'pointer inactive'
              "
              class="pointer mt-2"
              @click="activeItem('settings/users')"
            >
              Users
            </div>
          </div>
        </v-list-group>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  name: "EmployerSideBar",
  data() {
    return {
      miniVersion: true,
      item: "home",
      items: [
        {
          icon: "fas fa-home",
          title: "Home",
        },
        {
          icon: "fas fa-users",
          title: "Clients",
        },
        {
          icon: "fas fa-cog",
          title: "Settings",
        },
      ],
    };
  },
  props: {
    windowWidth: {
      type: Boolean,
    },
    mini: {
      type: Boolean,
    },
  },
  computed: {
    showMini() {
      return this.mini;
    },
    routeParams() {
      let route = "";
      if (this.$route.params.name) {
        route = this.$route.params.name.replace(/ /g, "%20");
      }
      return route;
    },
    watchActiveItem() {
      if (this.$route.path.includes("/employer/settings/users")) {
        this.item = "settings/users";
      } else if (this.$route.path.includes("/employer/settings/account")) {
        this.item = "settings/account";
      } else if (this.$route.path.includes("wizard")) {
        this.item = "home";
      }else if (this.$route.path.includes(this.$route.path.split("/")[2])) {
        this.item = this.$route.path.split("/")[2];
      }
      return this.item;
    },
  },

  methods: {
    activeItem(tab) {
      if (this.$route.path != `/employer/${tab}`) {
        this.$router.push(`/employer/${tab}`);
      }

      if (!this.windowWidth) {
        this.$emit("closeSideBar");
      }
    },
  },
};
</script>
